import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { HvDropdown, ListValueProp } from "@hitachivantara/uikit-react-core";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { useFormikContext } from "formik";

import { parseStatus as ps, parseStatusMessage as psm } from "lib/utils/forms";

import { IncidentType } from "lib/api";

import Icon from "../../../common/Icon";
import useStyles from "./styles";

const fasIconsNames = [
  "adjust",
  "adn",
  "ambulance",
  "anchor",
  "android",
  "angellist",
  "apple",
  "archive",
  "circle",
  "asterisk",
  "at",
  "backward",
  "ban",
  "bar-chart",
  "bar-chart-o",
  "barcode",
  "bars",
  "bed",
  "beer",
  "behance",
  "behance-square",
  "bell",
  "bell-o",
  "bell-slash",
  "bell-slash-o",
  "bicycle",
  "binoculars",
  "birthday-cake",
  "bitbucket",
  "bitbucket-square",
  "bitcoin",
  "bold",
  "bomb",
  "book",
  "bookmark",
  "bookmark-o",
  "briefcase",
  "btc",
  "bug",
  "building",
  "building-o",
  "bullhorn",
  "bullseye",
  "bus",
  "buysellads",
  "calculator",
  "calendar",
  "calendar-o",
  "camera",
  "camera-retro",
  "car",
  "cart-arrow-down",
  "cart-plus",
  "cc",
  "cc-amex",
  "cc-discover",
  "cc-mastercard",
  "cc-paypal",
  "cc-stripe",
  "cc-visa",
  "certificate",
  "chain",
  "chain-broken",
  "check",
  "check-circle",
  "check-circle-o",
  "check-square",
  "check-square-o",
  "child",
  "circle-o",
  "circle-o-notch",
  "circle-thin",
  "clipboard",
  "clock-o",
  "close",
  "cloud",
  "cloud-download",
  "cloud-upload",
  "cny",
  "code",
  "code-fork",
  "codepen",
  "coffee",
  "cogs",
  "columns",
  "comment",
  "comment-o",
  "comments",
  "comments-o",
  "compass",
  "compress",
  "connectdevelop",
  "copy",
  "copyright",
  "crop",
  "crosshairs",
  "css3",
  "cube",
  "cubes",
  "cut",
  "dashboard",
  "dashcube",
  "database",
  "delicious",
  "desktop",
  "deviantart",
  "diamond",
  "digg",
  "dollar",
  "download",
  "dropbox",
  "drupal",
  "edit",
  "eject",
  "empire",
  "envelope",
  "envelope-o",
  "envelope-square",
  "eraser",
  "euro",
  "exchange",
  "exclamation",
  "exclamation-circle",
  "exclamation-triangle",
  "expand",
  "external-link",
  "external-link-square",
  "eye",
  "eye-slash",
  "eyedropper",
  "facebook",
  "facebook-f",
  "facebook-official",
  "facebook-square",
  "fax",
  "female",
  "file",
  "file-archive-o",
  "file-audio-o",
  "file-code-o",
  "file-excel-o",
  "file-image-o",
  "file-movie-o",
  "file-o",
  "file-pdf-o",
  "file-photo-o",
  "file-picture-o",
  "file-powerpoint-o",
  "file-sound-o",
  "file-text",
  "file-text-o",
  "file-video-o",
  "file-word-o",
  "file-zip-o",
  "film",
  "filter",
  "fire",
  "fire-extinguisher",
  "flag",
  "flag-checkered",
  "flag-o",
  "flask",
  "flickr",
  "folder",
  "folder-o",
  "folder-open",
  "folder-open-o",
  "font",
  "forumbee",
  "forward",
  "foursquare",
  "frown-o",
  "gamepad",
  "gbp",
  "genderless",
  "gift",
  "git",
  "git-square",
  "github",
  "github-alt",
  "github-square",
  "gittip",
  "globe",
  "google",
  "google-plus",
  "google-plus-square",
  "google-wallet",
  "graduation-cap",
  "gratipay",
  "group",
  "h-square",
  "header",
  "heart",
  "heart-o",
  "heartbeat",
  "history",
  "home",
  "hospital-o",
  "hotel",
  "html5",
  "ils",
  "image",
  "inbox",
  "indent",
  "info",
  "info-circle",
  "inr",
  "instagram",
  "ioxhost",
  "italic",
  "joomla",
  "jpy",
  "jsfiddle",
  "key",
  "keyboard-o",
  "krw",
  "laptop",
  "lastfm",
  "lastfm-square",
  "leaf",
  "leanpub",
  "legal",
  "lemon-o",
  "lightbulb-o",
  "linkedin",
  "linkedin-square",
  "linux",
  "list",
  "list-alt",
  "list-ol",
  "list-ul",
  "lock",
  "magic",
  "magnet",
  "mail-forward",
  "mail-reply",
  "male",
  "map-marker",
  "mars",
  "mars-double",
  "mars-stroke",
  "mars-stroke-h",
  "mars-stroke-v",
  "maxcdn",
  "meanpath",
  "medium",
  "medkit",
  "meh-o",
  "mercury",
  "microphone",
  "microphone-slash",
  "minus",
  "minus-circle",
  "minus-square",
  "minus-square-o",
  "mobile",
  "mobile-phone",
  "money",
  "moon-o",
  "motorcycle",
  "music",
  "neuter",
  "newspaper-o",
  "openid",
  "outdent",
  "pagelines",
  "paragraph",
  "paste",
  "pause",
  "paw",
  "paypal",
  "pencil",
  "pencil-square",
  "pencil-square-o",
  "phone",
  "phone-square",
  "picture-o",
  "pinterest",
  "pinterest-p",
  "pinterest-square",
  "plane",
  "play",
  "play-circle",
  "play-circle-o",
  "plug",
  "plus",
  "plus-circle",
  "plus-square",
  "plus-square-o",
  "power-off",
  "print",
  "puzzle-piece",
  "qq",
  "qrcode",
  "question",
  "question-circle",
  "random",
  "rebel",
  "recycle",
  "reddit",
  "reddit-square",
  "refresh",
  "remove",
  "renren",
  "repeat",
  "reply",
  "reply-all",
  "retweet",
  "rmb",
  "road",
  "rocket",
  "rouble",
  "rss",
  "rss-square",
  "rub",
  "ruble",
  "rupee",
  "save",
  "search",
  "search-minus",
  "search-plus",
  "sellsy",
  "send",
  "send-o",
  "server",
  "share",
  "share-alt",
  "share-alt-square",
  "share-square",
  "share-square-o",
  "shekel",
  "sheqel",
  "shield",
  "ship",
  "shirtsinbulk",
  "signal",
  "simplybuilt",
  "sitemap",
  "skyatlas",
  "skype",
  "slack",
  "sliders",
  "slideshare",
  "smile-o",
  "soccer-ball-o",
  "sort",
  "sort-alpha-asc",
  "sort-alpha-desc",
  "sort-amount-asc",
  "sort-amount-desc",
  "sort-asc",
  "sort-desc",
  "sort-down",
  "sort-numeric-asc",
  "sort-numeric-desc",
  "sort-up",
  "soundcloud",
  "spinner",
  "spoon",
  "spotify",
  "square",
  "square-o",
  "star",
  "star-half",
  "star-half-empty",
  "star-half-full",
  "star-half-o",
  "star-o",
  "steam",
  "steam-square",
  "stop",
  "strikethrough",
  "stumbleupon",
  "stumbleupon-circle",
  "subscript",
  "subway",
  "suitcase",
  "sun-o",
  "superscript",
  "table",
  "tablet",
  "tag",
  "tags",
  "tasks",
  "taxi",
  "terminal",
  "ticket",
  "tint",
  "train",
  "transgender",
  "transgender-alt",
  "trash",
  "trash-o",
  "tree",
  "trello",
  "trophy",
  "truck",
  "try",
  "tty",
  "tumblr",
  "tumblr-square",
  "twitch",
  "twitter",
  "twitter-square",
  "umbrella",
  "underline",
  "undo",
  "university",
  "unlock",
  "unlock-alt",
  "upload",
  "usd",
  "user",
  "user-md",
  "user-plus",
  "user-secret",
  "user-times",
  "users",
  "venus",
  "venus-double",
  "venus-mars",
  "viacoin",
  "video-camera",
  "vimeo-square",
  "vine",
  "vk",
  "warning",
  "wechat",
  "weibo",
  "weixin",
  "whatsapp",
  "wheelchair",
  "wifi",
  "windows",
  "won",
  "wordpress",
  "wrench",
  "xing",
  "xing-square",
  "yahoo",
  "yelp",
  "yen",
  "youtube",
  "youtube-play",
  "youtube-square",
];
const IconFontAwesomeDropdown: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation("addEditIncidentType");

  const {
    values,
    errors,
    touched,
    status: { serverSideErrors = {} },
    setFieldValue,
    setFieldTouched,
  } = useFormikContext<Partial<IncidentType>>();

  const parseStatus = useCallback(
    (field: string) => ps(field, serverSideErrors, errors, touched),
    [errors, serverSideErrors, touched]
  );

  const parseStatusMessage = useCallback(
    (field: string) => psm(field, serverSideErrors, errors, touched),
    [errors, serverSideErrors, touched]
  );

  const onChange = useCallback(
    (selection: ListValueProp | ListValueProp[] | undefined) => {
      const selectedValue = selection as ListValueProp;
      setFieldValue("appearance.icon", selectedValue ? selectedValue.id : null);
    },
    [setFieldValue]
  );

  const onToggle = useCallback(() => {
    setFieldTouched("appearance.icon", true, false);
  }, [setFieldTouched]);

  const iconValues = useMemo(
    () =>
      fasIconsNames.sort().map((iconName) => {
        return {
          id: iconName,
          label: (
            <>
              <div role="presentation" className={classes.iconContainer}>
                <Icon
                  iconData={{
                    icon_type: "fontawesome",
                    icon: iconName as IconName,
                  }}
                />
              </div>
              <span className={classes.textContainer}>{iconName}</span>
            </>
          ),
          searchValue: iconName,
          selected: values?.appearance?.icon === iconName,
        };
      }),
    [classes.iconContainer, classes.textContainer, values?.appearance?.icon]
  );

  const disabled = useMemo(
    () => values?.appearance?.icon_type !== "fontawesome",
    [values?.appearance?.icon_type]
  );

  return (
    <HvDropdown
      className={classes.fontAwesomeDropdown}
      values={iconValues}
      aria-labelledby="fontAwesomeIconRadio-label"
      placeholder={t("mapMarker.iconType.options.fontAwesomeIcon.placeholder")}
      showSearch
      disabled={disabled}
      status={!disabled ? parseStatus("appearance.icon") : "valid"}
      statusMessage={!disabled && parseStatusMessage("appearance.icon")}
      onChange={onChange}
      onToggle={onToggle}
      virtualized
      height={300}
    />
  );
};

export default IconFontAwesomeDropdown;
